import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";

export interface RewardsRouteSearch {
  reward?: string;
}

function toRewardsRouteSearch(raw: unknown): RewardsRouteSearch {
  if (!raw || typeof raw !== "object") {
    return {};
  }

  const reward = (raw as Record<string, unknown>).reward;
  if (typeof reward !== "string") {
    return {};
  }

  const trimmedReward = reward.trim();
  return trimmedReward ? { reward: trimmedReward } : {};
}

export const Route = createFileRoute("/_app/rewards")({
  head: () => ({
    meta: [
      { title: m.rewards_page_meta_title() },
      { content: m.rewards_page_meta_description(), name: "description" },
    ],
  }),
  loader: ({ context }) => {
    void import("~/features/campaigns/campaigns-route").then(
      ({ preloadCampaignsRoute: preloadRewardsRoute }) => {
        void preloadRewardsRoute(context);
      },
    );
    void import("~/features/referrals/referrals-route").then(
      ({ preloadReferralsRoute }) => {
        void preloadReferralsRoute(context);
      },
    );
  },
  validateSearch: (raw): RewardsRouteSearch => toRewardsRouteSearch(raw),
});
